export class ChatSetting {
    constructor() {
        this.EMOTION_NAME_PREFIX = "chat-emotion-img";
        this.UPLOAD_IMAGE_MAX_COUNT = 1;
        this.UPLOAD_IMAGE_MAX_SIZE = 20971520;
        this.MESSAGE_SEND_INTERVAL_THRESHOLD = 1; //seconds
        this.MESSAGE_CONTENT_MAX_SIZE = 500;
        this.BET_CONTENT_MAX_SIZE = 200;
        this.ANNOUNCEMENT_MAX_SIZE = 500;
        this.GROUP_ROOM_NAME_MAX_SIZE = 30;
        this.CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE = 100;
        // 檢查送signalr前確認是否有連線的功能開關
        // 先開個DF用，之後每個站都有就不用這個變數了
        this.ENABLE_CHECK_CONNECTION_BEFORE_ACTION = false;

        this.functionNames = {
            SEND_MESSAGE: "送出讯息",
            ADD_CUSTOMER_SERVICE_WAITING: "询问客服",
            LOAD_HISTORY_MESSAGE: "载入历史讯息",
            LOAD_GROUP_ROOM_MEMBER: "载入群组成员",
            ADD_GROUP_ROOM: "新增群组",
            REMOVE_GROUP_ROOM: "删除群组",
            SET_GROUP_ROOM_NAME: "设定群组名称",
            CHAT_ADD_GROUP_ROOM_MEMBER: "新增群组成员",
            CHAT_REMOVE_GROUP_ROOM_MEMBER: "删除群组成员",
            CLEAR_HISTORY_MESSAGE: "清屏",
            CHAT_UPDATE_GROUP_ROOM_READONLY: "群组全体禁言",
            CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY: "群组成员禁言",
            CHAT_UPLOAD_IMAGE:"上传图片",
            CHAT_SET_GROUP_ROOM_ANNOUNCEMENT: "群组公告",
            CHAT_SET_GROUP_ROOM_MEMBER_ROLE: "群组成员权限",
            CHAT_ADD_JSON_GROUP_ROOM_ANNOUNCEMENT: "群组公告-新增",
            CHAT_REMOVE_JSON_GROUP_ROOM_ANNOUNCEMENT: "群组公告-删除",
            CUSTOMER_SERVICE_RATING: "客服评分",
            ENTRY_SITE_GROUP_ROOM: "进入群聊房间",
            SITE_GROUP_REMOVE_MESSAGE: "全站群聊删除讯息",
            SITE_GROUP_GET_MESSAGE_USER_INFO: "全站群聊取得用户资讯",
            SITE_GROUP_UPDATE_MEMBER_READONLY: "全站群聊成员禁言",
            SITE_GROUP_CLEAR_MESSAGE: "全站群聊清屏",
            SITE_GROUP_SET_PIN_MESSAGE: "全站群聊置顶",
            SITE_GROUP_SEARCH_MEMBER: "全站群聊搜寻用户",
            SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM: "全站群聊移除近期导师聊天房间",
            SITE_GROUP_GET_ROOM_MEMBER_LIST: "全站群聊取得群聊聊天室会员清单",
        };

        this.messages = {
            // 一般
            MESSAGE_USER_LEVEL: (level) => `VIP${level}`,
            CLEAR_HISTORY_MESSAGE_HINT: () => `是否要执行清屏?`,
            SITE_GROUP_CLEAR_MESSAGE_HINT: () => `是否要执行清屏?`,
            SITE_GROUP_REMOVE_TUTOR_RECENT_ROOM_HINT: () => `是否删除导师对话?`,
            // 客服相關
            CUSTOMER_SERVICE_WAITING: () => `您好，请稍等片刻，客服会尽快给您服务，感谢您的耐心等待，谢谢`,
            CUSTOMER_SERVICE_SERVING: () => `您目前已在与客服交谈中`,
            CUSTOMER_SERVICE_SERVING_FINISH: () => `本次聊天已结束`,
            CUSTOMER_SERVICE_QUESTION_LIST: () => `提交客服请求中...`,
            CUSTOMER_SERVICE_CHAT_NOT_INIT: () => '您尚未提出客服请求',
            CUSTOMER_SERVICE_CHAT_NOT_INIT_ON_ANONYMITY: () => '请重新进入页面',
            ANONYMITY_WELCOME: () => '您好，请先送出问题讯息后，等待客服回应，谢谢',
            //下面是錯誤訊息
            FORBID: (name) => `您没有操作的权限 (${name})`,
            SYSTEM_FAILED: (name) => `伺服器错误，请重新进入页面或稍后再试，谢谢 (${name})`,
            NETWORK_FAILED: (name) => `网路异常，请重新进入页面或稍后再试，谢谢 (${name})`,
            UPLOAD_IMAGE_COUNT_EXCEED: () => '超过允许上传的档案数量',
            UPLOAD_IMAGE_SIZE_EXCEED: () => '超过允许的档案容量',
            UPLOAD_IMAGE_NOT_ALLOW_TYPE: () => '不允许的档案类型',
            UPLOAD_IMAGE_COMPRESS_FAILED: () => '压缩图片失败',
            MESSAGE_SEND_CONTENT_INVALID: () => '送出失败，讯息格式不正确',
            MESSAGE_SEND_INTERVAL_TOO_SHORT: () => '送出失败，讯息送出间隔时间太短',
            MESSAGE_SEND_CONTENT_IS_EMPTY: () => '送出失败，讯息内容为空',
            MESSAGE_SEND_CONTENT_TOO_LONG: () => '送出失败，讯息内容太长',
            GROUP_ROOM_NAME_ALREADY_EXISTED: () => '群组名称已存在',
            GROUP_ROOM_COUNT_EXCEED: () => '群组数量已超过',
            GROUP_ROOM_NAME_EMPTY: () => '群组名称为空',
            GROUP_ROOM_NAME_TOO_LONG: () => '群组名称太长',
            GROUP_ROOM_NAME_INVALID: () => '群组名称格式不正确',
            REMOVE_GROUP_ROOM_NOT_FOUND: () => '权限不足或没有此聊天室',
            ADD_GROUP_ROOM_MEMBER_MODIFIED_ROOM_COUNT_EXCEED: () => '单次修改聊天室数量太多',
            ADD_GROUP_ROOM_MEMBER_ROOM_NOT_FOUND: () => '权限不足或没有此聊天室',
            ADD_GROUP_ROOM_MEMBER_ROOM_FOBID: () => '权限不足',
            ADD_GROUP_ROOM_MEMBER_MEMBER_NOT_EXISTED: () => '没有此成员',
            ADD_GROUP_ROOM_MEMBER_MEMBER_COUNT_EXCEED: () => '成员数量已超过',
            ADD_GROUP_ROOM_MEMBER_EXISTED: (loginIds) => `${loginIds} 成员已存在群组内`,
            REMOVE_GROUP_ROOM_MEMBER_MODIFIED_ROOM_COUNT_EXCEED: () => '单次修改聊天室数量太多',
            REMOVE_GROUP_ROOM_MEMBER_ROOM_NOT_FOUND: () => '没有此聊天室',
            REMOVE_GROUP_ROOM_MEMBER_FOBID: () => '权限不足',
            REMOVE_GROUP_ROOM_MEMBER_MEMBER_NOT_EXISTED: () => '没有此成员',
            GET_GROUP_ROOM_MEMBER_FORBID: () => '权限不足',
            ANONYMITY_ROOM_DATA_NOT_FOUND: () => '资料错误，请重新进入页面',
            ANONYMITY_LOGIN_ID_NOT_FOUND: () => '输入账号不存在!!',
            UPDATE_GROUP_ROOM_READONLY_ROOM_NOT_FOUND: () => '没有此聊天室',
            UPDATE_GROUP_ROOM_READONLY_FOBID: () => '权限不足',
            UPDATE_GROUP_ROOM_MEMBER_READONLY_ROOM_NOT_FOUND: () => '没有此聊天室',
            UPDATE_GROUP_ROOM_MEMBER_READONLY_FOBID: () => '权限不足',
            UPDATE_GROUP_ROOM_MEMBER_READONLY_MEMBER_NOT_EXISTED: () => '没有此成员',
            SET_GROUP_ROOM_ANNOUNCEMENT_ROOM_NOT_FOUND: () => '没有此聊天室',
            SET_GROUP_ROOM_ANNOUNCEMENT_FOBID: () => '权限不足',
            SET_GROUP_ROOM_ANNOUNCEMENT_EMPTY: () => '请输入公告内容',
            SET_GROUP_ROOM_ANNOUNCEMENT_TOO_LONG: () => '公告内容太长',
            SET_GROUP_ROOM_ANNOUNCEMENT_MAX_SIZE: (max) => `公告内容最大长度${max}`,
            REMOVE_GROUP_ROOM_ANNOUNCEMENT_ASK_CONFIRM: () => '是否删除此条公告?',
            JSON_GROUP_ROOM_ANNOUNCEMENT_COUNT_EXCEED: () => '公告数量已超过',
            JSON_GROUP_ROOM_ANNOUNCEMENT_EMPTY: () => '请输入公告内容',
            JSON_GROUP_ROOM_ANNOUNCEMENT_RMOVE_ID_EMPTY: () => '请选择要删除的公告',
            SET_GROUP_ROOM_MEMBER_ROLE_ROOM_NOT_FOUND: () => '没有此聊天室',
            SET_GROUP_ROOM_MEMBER_ROLE_FOBID: () => '权限不足',
            SET_GROUP_ROOM_MEMBER_ROLE_MEMBER_NOT_EXISTED: () => '没有此成员',
            MULTICAST_GROUP_ROOM_MAX_SIZE: (max) => `群组广播内容最大长度${max}`,
            SITE_GROUP_COUNT_EXCEED: () => '房间人数已满',
            SITE_GROUP_VIP_LEVEL_NOT_MATCH: () => '用户等级不够不能进入聊天室',
            SITE_GROUP_PASSWORD_INCORRECT: () => '房间密码错误',
            SITE_GROUP_DAILY_DEPOSIT_NOT_ENOUGH: (amount) => `当前充值量未达标准，还差${amount}元`,
            SITE_GROUP_DAILY_BET_NOT_ENOUGH_LOTTERY: (amount) => `当前彩票投注量未达标准，还差${amount}元`,
            SITE_GROUP_DAILY_BET_NOT_ENOUGH_EXTERNAL_GAME: (amount) => `当前外接游戏投注量未达标准，还差${amount}元`,
            SITE_GROUP_DAILY_BET_NOT_ENOUGH_LOTTERY_AND_EXTERNAL_GAME: (amount) => `当前彩票、外接游戏投注量未达标准，还差${amount}元`,
            SITE_GROUP_REMOVE_MESSAGE_SUCCESS: () => '撤回成功',
            SITE_GROUP_REMOVE_MESSAGE_NOT_FOUND: () => '找不到讯息',
            SITE_GROUP_REMOVE_MESSAGE_FORBID: () => '权限不足',
            SITE_GROUP_GET_MESSAGE_USER_INFO_NOT_FOUND: () => '找不到讯息',
            SITE_GROUP_GET_MESSAGE_USER_INFO_FORBID: () => '权限不足',
            SITE_GROUP_UPDATE_MEMBER_READONLY_SUCCESS: () => '禁言成功',
            SITE_GROUP_UPDATE_MEMBER_READONLY_ALREADY_EXISTED: () => '成员已禁言',
            SITE_GROUP_UPDATE_MEMBER_READONLY_FOBID: () => '非导师权限无法禁言',
            SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_FOUND: () => '找不到讯息',
            SITE_GROUP_UPDATE_MEMBER_READONLY_NOT_EXISTED: () => '没有此成员',
            SITE_GROUP_CLEAR_MESSAGE_SUCCESS: () => '清屏成功',
            SITE_GROUP_CLEAR_MESSAGE_FOBID: () => '非导师权限无法清屏',
            SITE_GROUP_SET_PIN_MESSAGE_SUCCESS: () => '置顶成功',
            SITE_GROUP_SET_PIN_MESSAGE_FOBID: () => '非导师权限无法置顶',
            SITE_GROUP_SET_PIN_MESSAGE_NOT_FOUND: () => '找不到讯息',
            SITE_GROUP_SEARCH_MEMBER_FORBID: () => '非导师权限无法查询',
            SITE_GROUP_SEARCH_MEMBER_NOT_EXISTED: () => '查无资料',
            //聊天室紅包活動
            RED_PACK_MAINTAIN: (financialDay) => `每日00:00~${financialDay}:00，为红包功能定期维护时间，不开放红包创建`,
            RED_PACK_TRY_CONFIRM: (totalPrize, walletAmount) => `建立【试手气红包】<br>是否提款${totalPrize}元?<br>彩票中心尚有${walletAmount}元`,
            RED_PACK_AVERAGE_CONFIRM: (totalPrize, walletAmount) => `建立【标准红包】<br>是否提款${totalPrize}元?<br>彩票中心尚有${walletAmount}元`,
            RED_PACK_ACTIVITY_RECEIVE: () => '已领取红包',
            //客服評分系統
            SET_CUSTOMER_SERVICE_RATING_EXISTED: () => '您已该客服评分过，请下次再操作',
            SET_CUSTOMER_SERVICE_RATING_NOT_EXISTED: () => '无指定客服服务纪录无法评分',
            SET_CUSTOMER_SERVICE_RATING_NOT_SESSION_ID: () => '尚无客服协助此次服务无法评分',
            SET_CUSTOMER_SERVICE_RATING_CONTENT_MAX_SIZE: (max) => `评价内容最大长度${max}`
        };

        this.getWindowGroupNumber = (type) => 0;
    }
}

export default new ChatSetting();